<style lang="scss" scoped>
.slide-15 {
  background-image: url("../../../assets/module5/slide15/bg-01.jpg");
  background-size: cover;
  background-position: center;
  padding-top: 117px;
  padding-right: 162px;
  height: calc(100% - 117px);
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
h1 {
  font-size: 154px;
  color: #f8dc61;
  transform: rotate(-5deg);
  margin-bottom: 40px;
}
p {
  width: 505px;
  color: white;
  margin-right: 250px;
}
.email {
  display: block;
  width: 250px;
  margin-top: 40px;
  margin-right: 450px;
  img {
    width: 100%;
    height: auto;
  }
}
#pdfDocument {
  width: 1px;
  height: 1px;
  visibility: hidden;
}
</style>

<template>
  <div class="slide-15">
    <transition name="fadeLeft" appear>
      <img
        src="@/assets/module5/slide15/poster.png"
        class="chars"
        v-show="slideIndex == 14"
      />
    </transition>

    <transition name="fadeRight" appear>
      <img
        src="@/assets/module5/slide15/timmy-01.png"
        class="chars delay-3"
        v-show="slideIndex == 14"
      />
    </transition>

    <transition name="scale" appear>
      <div v-show="slideIndex == 14" class="delay-1">
        <h1>WELL DONE!</h1>
      </div>
    </transition>

    <transition name="scale" appear>
      <p v-show="slideIndex == 14" class="delay-2">
        Now that you know the correct answers, download the card here and send
        it to your Grandheroes so they can see your superhero friends again too.
      </p>
    </transition>

    <a href="" class="email" @click.prevent="downloadPdf">
      <transition name="scale" appear>
        <img
          v-show="slideIndex == 14"
          class="delay-3"
          src="@/assets/module5/slide15/2x/dowload_email_btn@2x.png"
          alt=""
        />
      </transition>
    </a>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      pdfLink:
        window?.CF_EBOOK_VARS?.documents?.book_5_document_2?.url ||
        "../01.-FAST_Heroes_Activities_W5_Def106.pdf",
      pdfId:
        window?.CF_EBOOK_VARS?.documents?.book_5_document_2?.document_id ||
        "test_id"
    };
  },
  props: ["slideIndex"],
  methods: {}
};
</script>
